

export class SearchRequest {
  localId: string;

  factoryId: string;

  searchKey: string;

  page: number;

  count: number;

  factoryCode: string = "ALL";

  constructor(page: number, count: number, localId: string, factoryId: string) {
    this.localId = localId ?? '';
    this.factoryId = factoryId;

    this.searchKey = '';

    this.page = page;
    this.count = count;
  }
}
